export default "__VITE_ASSET__DvAk7q31__"